import { co2 } from './common';

export default {
  'consumption.co2': `${co2} emissions combined`,
  'consumption.energy': 'Power consumption in combined test cycle',
  'consumption.fuel': 'Fuel consumption combined',
  'footnotes.local': '',
  'footnotes.wltp': `Les valeurs indiquées ont été déterminées selon les méthodes de mesure prescrites. Il s'agit des « valeurs ${co2} WLTP » au sens de l'article 2 nr. 3 du règlement d'exécution (EU) 2017/1153. Les valeurs de consommation ont été calculées sur la base de ces valeurs. La consommation électrique a été déterminée sur la base de la directive 692/2008/CE. Les valeurs indiquées ne sont pas liées à un véhicule en particulier. Elles ont pour seul but de permettre la comparaison entre différents véhicules. Les valeurs peuvent varier selon les équipements et options choisies.`,
  'footnotes.nedc': '',
  'footnotes.emissions.appendix': '',
  'search.input.label': 'Votre mot clé / code en ligne',
  'search.result.buy-online': 'Buy Online',
  'search.results':
    'Aucun résultat de recherche | {count} Résultat de la recherche | {count} Résultats de la recherche',
  'search.results.backup': 'Aucune correspondance exacte trouvée. Voir les pages liées:',
  'search.results.count': '{count} Résultats de la recherche',
  'search.results.none.summary':
    "Il n'y a pas de résultats de recherche disponibles pour ce terme. Veuillez réessayer avec un terme différent.",
  'search.show-more': 'En savoir plus',
  'search.title': 'Que cherchez-vous?',
  'search.unavailable': "La recherche n'est pas disponible actuellement.",
  'search.result.new': 'Nouveau',
  'input.placeholder': 'Votre mot clé / code en ligne',

  'search.result.consumption': 'Consommation',
  'watch.video': 'Regarder la vidéo',
  'input.recently': 'Récemment recherde_frché',
  'input.help.title': 'Que devriez-vous recherchez ?',
  'input.help.text':
    "Rechercher par types de véhicules, modèles, codes de configuration ou rechercher des accessoires, d'autres produits et informations",

  'search.result.grid': 'Grid',
  'search.result.list': 'List',

  all: 'Tous',
  UCOS: "Boutique en ligne véhicules d'occasion",
  PASSENGER_CARS: 'VP',
  VANS: 'Vans',
  NCOS: 'Boutique en ligne véhicules neufs',
  VIDEO: 'Vidéos',
  DEALER_LOCATOR: 'Recherche de distributeur',
  CONFIGURATOR: 'Configurez votre voiture',
  TEST_DRIVE: 'Essai sur route',
  VEHICLE_SEARCH: 'Recherche de véhicules d’occasion',
  COLLECT: 'Collection et accessoires',
  CONNECT: 'Mercedes me Store',
  ACCESSORIES: 'Accessoires de voiture',

  // No results found
  'support.check': 'Kuckt w.e.g. op Tippfehler oder probéiert nach eng Kéier mat engem anere Begrëff.',
  'support.no.results': 'Et gi keng Sichresultater fir dëse Sichbegrëff verfügbar.',
  'support.no.results.term': 'Keng Resultater fonnt',
  'support.chat': 'Kënnt Dir net fannen wat Dir sicht? Benotzt w.e.g. eisen ',
  'support.chat.with.us': 'Online-Chat-Support',

  'search.results.offer': 'Offres populaires pour "{query}":',
};
